<template>
  <v-skeleton-loader type="card-heading, image" />
</template>

<script>
export default {
};
</script>